export default function FixedNav($el) {
  const navBarClasses = $el.attr('class');

  $(window).on('scroll', () => {
    if ($(window).scrollTop() > 55) {
      $el.addClass('fixed');
    } else {
      $el.removeClass('fixed');
      $el.addClass(navBarClasses);
    }
  });
}
